import React, { useEffect, useState } from 'react';

import { Input, Label, UncontrolledTooltip } from 'reactstrap';
import { inputMask } from '../../../../utils/helpers/masks/masks';
import { validation } from '../../../../utils/helpers/masks/validations';

export default function EmailDisplay({ attributes, rowId, colId, setValue }) {
  // Mask — inicializa com attributes.value pra suportar pré-preenchimento
  // (ex: paxid identificado no PublicTemplate carrega o e-mail do attendee).
  const [maskedValue, setMaskedValue] = useState(attributes.value || '');

  // Validação
  const [emailError, setEmailError] = useState('');

  const handleChange = (value) => {
    // Whitelist estrita — só permite os caracteres válidos em emails
    // comuns: a-z (minúsculo), 0-9, . _ + - @. Converte pra minúsculo
    // antes do replace; assim maiúsculas viram lowercase (não são
    // rejeitadas) e acentos / espaços / caracteres exóticos são descartados
    // silenciosamente no momento da digitação.
    const cleaned = (value || "")
      .toLowerCase()
      .replace(/[^a-z0-9._+\-@]/g, "");
    setMaskedValue(cleaned);
  };

  useEffect(() => {
    const html = attributes.label;
    const div = document.getElementsByClassName(`email-label-${rowId}-${colId}`);
  
    for (const element of div) {
      element.innerHTML = html + (attributes.required ? '*' : '');
    }
  }, [attributes, rowId, colId])

  // Atualiza `value` imediatamente pra o submit não perder o valor atual.
  // Se o email é INVÁLIDO, limpa temporariamente o errorMessage pra não
  // exibir a mensagem enquanto o usuário ainda digita (o próximo effect
  // com debounce reintroduz depois de 600ms parado).
  useEffect(() => {
    setValue((oldValue) => {
      const newValue = [...oldValue];
      newValue[rowId].cols[colId].attributes.value = maskedValue;
      newValue[rowId].cols[colId].attributes.errorMessage = "";
      newValue[rowId].cols[colId].attributes.useRawErrorMessage = false;
      return newValue;
    });
  }, [maskedValue, setValue, rowId, colId]);

  // Validação com debounce — só mostra o erro após o usuário parar de
  // digitar. Evita "flicker" de "Email incompleto" a cada caractere.
  useEffect(() => {
    const timer = setTimeout(() => {
      const { isValid, message } = validation(maskedValue, "email");
      setEmailError(maskedValue && !isValid ? message : "");
      setValue((oldValue) => {
        const newValue = [...oldValue];
        // Só interfere se o valor ainda for o mesmo que validamos (evita
        // sobrescrever se o usuário tiver digitado mais no meio tempo).
        if (newValue[rowId].cols[colId].attributes.value !== maskedValue) {
          return oldValue;
        }
        const hasValue = maskedValue !== "";
        newValue[rowId].cols[colId].attributes.errorMessage = !isValid
          ? message
          : "";
        newValue[rowId].cols[colId].attributes.useRawErrorMessage =
          !isValid && hasValue;
        return newValue;
      });
    }, 600);

    return () => clearTimeout(timer);
  }, [maskedValue, setValue, rowId, colId]);

  return (
    <div>
      <div className="custom-input-container">
        <div>
          <div className="displayed-config-container">
            <div className="displayed-label">
              {/* FIX_SSR_LABEL — teste isolado com children + inline. */}
              <Label
                htmlFor="formText"
                className={`form-label email-label-${rowId}-${colId}`}
                style={{ display: "inline", marginRight: 2 }}
              >
                {attributes.label}
              </Label>
              {attributes.hasTip && (
                <div>
                  <div className="show-tips" id={`email-tip-${rowId}-${colId}`}>
                    <span>?</span>
                  </div>
                  <UncontrolledTooltip style={{ backgroundColor: '#6f42c1' }} placement="right" target={`email-tip-${rowId}-${colId}`}>
                    {attributes.tipText}
                  </UncontrolledTooltip>
                </div>
              )}
            </div>
          </div>
          <Input
            className="form-control"
            type="text"
            id="formText"
            placeholder={attributes.placeholder}
            value={maskedValue}
            readOnly={!!attributes.readOnly}
            disabled={!!attributes.disabled}
            onChange={({ target }) => handleChange(target.value)}
          />
        </div>
      </div>
    </div>
  )
}
